import {useQuery} from '@tanstack/react-query';
import type {ProductActivityView} from '@shared/productActivity';
/** One owner-scoped snapshot shared by the brand grid and all saved product pickers. */
export function useProductActivity(enabled=true){
 return useQuery<ProductActivityView[]>({
  queryKey:['/api/products/activity'],
  queryFn:async()=>{
   const response=await fetch('/api/products/activity',{credentials:'include'});
   if(!response.ok)throw new Error('Could not check product readiness');
   return response.json();
  },
  enabled,staleTime:0,refetchInterval:query=>query.state.error||query.state.data?.some(product=>product.label)?3000:8000,
 });
}
